import { MessageStatus } from '@govbr-ds/react-components/dist/types/messages';
import { IDeducaoAdicionada, IDeducaoRecebida } from 'interfaces/IDeducao';
import { removeFormatCurrency } from 'utils/formatCurrency';

export function validarCamposObrigatoriosSemBanho(
  receitaBrutaEstabelecimento: string,
  deducoes: IDeducaoAdicionada[],
  deducoesPossiveis: string[] | undefined,
  mostrarNotificacao: (notificacao: { tipo: MessageStatus; conteudo: string }) => void
): boolean {
  if (receitaBrutaEstabelecimento === '' || removeFormatCurrency(receitaBrutaEstabelecimento) === 0) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Informe a receita bruta do estabelecimento',
    });
    return false;
  }

  if (!deducoesPossiveis || deducoesPossiveis.length === 0) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Não foi possível validar as deduções. Tente novamente mais tarde.',
    });
    return false;
  }

  for (const deducao of deducoesPossiveis) {
    let deducaoPesquisada;
    deducaoPesquisada = deducoes.find((item) => item.nome == deducao);
    if (deducaoPesquisada === undefined) {
      mostrarNotificacao({
        tipo: 'danger',
        conteudo: `Nas deduções, informe o valor do ${deducao} mesmo que seja zero`,
      });
      return false;
    }
  }

  return true;
}

export function validarCamposObrigatoriosComBanho(
  valorBanho: string,
  quantidade: string,
  mostrarNotificacao: (notificacao: { tipo: MessageStatus; conteudo: string }) => void
): boolean {
  if (valorBanho === '' || removeFormatCurrency(valorBanho) === 0) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Informe o valor do banho',
    });
    return false;
  }

  if (quantidade === '' || parseFloat(quantidade) === 0) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Informe a quantidade',
    });
    return false;
  }

  return true;
}
